import React from 'react';
import styled from 'styled-components';
import {
  DiscoverDatetime,
  DiscoverDatetimeFormData,
} from '~admin/view/components/details/event-details/event-datetime-details/discover-datetime.component';
import {
  DoorsDatetime,
  DoorsDatetimeFormData,
} from '~admin/view/components/details/event-details/event-datetime-details/doors-datetime.component';
import {
  EventDatetime,
  EventDatetimeFormData,
} from '~admin/view/components/details/event-details/event-datetime-details/event-datetime.component';
import { Column } from '~common/components/column.component';

export interface EventDatetimeDetailsFormData
  extends EventDatetimeFormData,
    DiscoverDatetimeFormData,
    DoorsDatetimeFormData {}

export const EventDatetimeDetails: React.FunctionComponent = () => {
  return (
    <Container>
      <EventDatetime />
      <Divider />
      <DiscoverDatetime />
      <Divider />
      <DoorsDatetime />
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background: ${(props): string => props.theme.colors.gray.v3};
  margin-top: 24px;
  margin-bottom: 6px;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-datetime-details.component.tsx